// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import API from "../Context/api";
// import Spinner from "../Helpers/Spinner";

// const ComputerReport = () => {
//   const { id } = useParams();
//   const [computer, setComputer] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchComputer = async () => {
//       try {
//         const response = await API.get(`/computers/${id}`);
//         setComputer(response.data);
//         console.log(response.data);
//       } catch (err) {
//         setError("Failed to fetch computer details.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchComputer();
//   }, [id]);

//   const handlePrint = () => {
//     window.print();
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <Spinner />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <p className="text-lg text-red-600 font-medium bg-red-100 p-4 rounded-lg">
//           {error}
//         </p>
//       </div>
//     );
//   }

//   if (!computer) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <p className="text-lg text-gray-600 font-medium">No data found.</p>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-4xl mx-auto p-4 sm:p-6 md:p-8 bg-white shadow-lg rounded-lg min-h-[calc(100vh-2rem)] flex flex-col font-sans print:shadow-none print:bg-white">
//       {/* Header */}
//       <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 pb-4 border-b border-gray-200">
//         <div className="mb-4 sm:mb-0">
//           <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
//             Computer Repair Report
//           </h1>
//           <p className="text-xs sm:text-sm text-gray-500 mt-1">
//             Asset ID: {computer.serialNumber || "N/A"}
//           </p>
//         </div>
//         <button
//           onClick={handlePrint}
//           className="bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 transition-colors duration-200 text-sm print:hidden"
//         >
//           Print Report
//         </button>
//       </header>

//       {/* Main Content */}
//       <div className="flex-1 space-y-6">
//         {/* Computer Info */}
//         <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
//           <h2 className="text-xl font-semibold text-gray-800 mb-3">
//             Computer Details
//           </h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Name</span>
//               <span className="text-gray-600">{computer.name || "N/A"}</span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Serial Number</span>
//               <span className="text-gray-600">
//                 {computer.serialNumber || "N/A"}
//               </span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Make</span>
//               <span className="text-gray-600">{computer.make || "N/A"}</span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Created By</span>
//               <span className="text-gray-600">
//                 {computer.createdBy || "N/A"}
//               </span>
//             </div>
//           </div>
//         </section>

//         {/* Repair Details */}
//         <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
//           <h2 className="text-xl font-semibold text-gray-800 mb-3">
//             Repair Details
//           </h2>
//           <div className="space-y-3 text-sm">
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Technician</span>
//               <span className="text-gray-600">
//                 {computer.repairDetails?.resourceassigned || "Not Assigned"}
//               </span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Status</span>
//               {/* <span
//                 className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
//                   computer.repairDetails?.status === "in_progress"
//                     ? "bg-yellow-100 text-yellow-800"
//                     : computer.repairDetails?.status === "completed"
//                     ? "bg-green-100 text-green-800"
//                     : "bg-gray-100 text-gray-600"
//                 }`}
//               >
//                 {computer.repairDetails?.status?.replace("_", " ") || "N/A"}
//               </span> */}
//               <span>{computer.repairDetails?.status}</span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Last Updated</span>
//               <span className="text-gray-600">
//                 {computer.repairDetails?.date
//                   ? new Date(computer.repairDetails.date).toLocaleDateString(
//                       "en-US",
//                       {
//                         year: "numeric",
//                         month: "short",
//                         day: "numeric",
//                       }
//                     )
//                   : "N/A"}
//               </span>
//             </div>
//             <div className="flex flex-col">
//               <span className="font-medium text-gray-700">Recommendations</span>
//               <span className="text-gray-600">
//                 {computer.repairDetails?.recommendations || "None"}
//               </span>
//             </div>
//           </div>
//         </section>

//         {/* Repair History */}
//         <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
//           <h2 className="text-xl font-semibold text-gray-800 mb-3">
//             Repair History
//           </h2>
//           {computer.repairHistory?.length > 0 ? (
//             <div className="space-y-3">
//               {computer.repairHistory.map((entry, index) => (
//                 <div
//                   key={index}
//                   className="bg-white p-3 rounded-md border-l-4 border-blue-500 text-sm"
//                 >
//                   <p>
//                     <span className="font-medium text-gray-700">Date: </span>
//                     {entry.date
//                       ? new Date(entry.date).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "short",
//                           day: "numeric",
//                         })
//                       : "N/A"}
//                   </p>
//                   <p>
//                     <span className="font-medium text-gray-700">
//                       Description:{" "}
//                     </span>
//                     {entry.description || "No description"}
//                   </p>
//                   <p>
//                     <span className="font-medium text-gray-700">Status: </span>
//                     {/* <span
//                       className={`text-xs font-medium px-2 py-1 rounded-full ${
//                         entry.status?.toLowerCase() === "in_progress"
//                           ? "bg-yellow-100 text-yellow-800"
//                           : entry.status?.toLowerCase() === "completed"
//                           ? "bg-green-100 text-green-800"
//                           : "bg-gray-100 text-gray-600"
//                       }`}
//                     >
//                       {entry.status || "Unknown"}
//                     </span> */}
//                     <span>{entry.status}</span>
//                   </p>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-gray-500 italic text-sm">
//               No repair history available.
//             </p>
//           )}
//         </section>

//         {/* Change History */}
//         <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
//           <h2 className="text-xl font-semibold text-gray-800 mb-3">
//             Change History
//           </h2>
//           {computer.changeHistory?.length > 0 ? (
//             <div className="space-y-3">
//               {computer.changeHistory.map((entry, index) => (
//                 <div
//                   key={index}
//                   className="bg-white p-3 rounded-md border-l-4 border-indigo-500 text-sm"
//                 >
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                     <div>
//                       <p>
//                         <span className="font-medium text-gray-700">
//                           Modified By:{" "}
//                         </span>
//                         <span className="text-indigo-600">
//                           {entry.changedby || entry.changedBy || "Unknown"}
//                         </span>
//                       </p>
//                       <p>
//                         <span className="font-medium text-gray-700">
//                           Date:{" "}
//                         </span>
//                         {entry.date
//                           ? new Date(entry.date).toLocaleDateString("en-US", {
//                               year: "numeric",
//                               month: "short",
//                               day: "numeric",
//                             })
//                           : "N/A"}
//                       </p>
//                       <p>
//                         <span className="font-medium text-gray-700">
//                           Field Changed:{" "}
//                         </span>
//                         {entry.field
//                           ? entry.field
//                               .split(/(?=[A-Z])|_/)
//                               .map(
//                                 (word) =>
//                                   word.charAt(0).toUpperCase() + word.slice(1)
//                               )
//                               .join(" ")
//                           : "Unknown"}
//                       </p>
//                     </div>
//                     <div>
//                       <p>
//                         <span className="font-medium text-gray-700">
//                           Previous Value:{" "}
//                         </span>
//                         <span className="text-red-500 italic">
//                           {entry.oldvalue || entry.oldValue || "N/A"}
//                         </span>
//                       </p>
//                       <p>
//                         <span className="font-medium text-gray-700">
//                           New Value:{" "}
//                         </span>
//                         <span className="text-green-500">
//                           {entry.newvalue || entry.newValue || "N/A"}
//                         </span>
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-gray-500 italic text-sm">
//               No change history available.
//             </p>
//           )}
//         </section>
//       </div>

//       {/* Footer */}
//       <footer className="mt-6 text-center text-gray-500 text-xs border-t pt-3">
//         <p>
//           Generated on{" "}
//           {new Date().toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "short",
//             day: "numeric",
//           })}
//         </p>
//       </footer>
//     </div>
//   );
// };

// export default ComputerReport;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../Context/api";
import Spinner from "../Helpers/Spinner";

const ComputerReport = () => {
  const { id } = useParams();
  const [computer, setComputer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchComputer = async () => {
      try {
        const response = await API.get(`/computers/${id}`);
        setComputer(response.data);
        console.log(response.data);
      } catch (err) {
        setError("Failed to fetch computer details.");
      } finally {
        setLoading(false);
      }
    };

    fetchComputer();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-lg text-red-600 font-medium bg-red-100 p-4 rounded-lg">
          {error}
        </p>
      </div>
    );
  }

  if (!computer) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-lg text-gray-600 font-medium">No data found.</p>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 md:p-8 bg-white shadow-lg rounded-lg min-h-[calc(100vh-2rem)] flex flex-col font-sans print:shadow-none print:bg-white">
      {/* Header */}
      <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 pb-4 border-b border-gray-200">
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
            Computer Repair Report
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">
            Asset ID: {computer.fields.SerialNumber || "N/A"}
          </p>
        </div>
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 transition-colors duration-200 text-sm print:hidden"
        >
          Print Report
        </button>
      </header>

      {/* Main Content */}
      <div className="flex-1 space-y-6">
        {/* Computer Info */}
        <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            Computer Details
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Name</span>
              <span className="text-gray-600">
                {computer.fields.Name || "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Serial Number</span>
              <span className="text-gray-600">
                {computer.fields.SerialNumber || "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Make</span>
              <span className="text-gray-600">
                {computer.fields.Make || "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Created By</span>
              <span className="text-gray-600">
                {computer.fields.CreatedBy || "N/A"}
              </span>
            </div>
          </div>
        </section>

        {/* Repair Details */}
        <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            Repair Details
          </h2>
          <div className="space-y-3 text-sm">
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Technician</span>
              <span className="text-gray-600">
                {computer.repairDetails?.ResourceAssigned || "Not Assigned"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Status</span>
              {/* <span
                className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${
                  computer.repairDetails?.Status === "in_progress"
                    ? "bg-yellow-100 text-yellow-800"
                    : computer.repairDetails?.Status === "completed"
                    ? "bg-green-100 text-green-800"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {computer.repairDetails?.Status?.replace("_", " ") || "N/A"}
              </span> */}
              <span>{computer.repairDetails?.Status}</span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Last Updated</span>
              <span className="text-gray-600">
                {computer.repairDetails?.Date
                  ? new Date(computer.repairDetails.Date).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      }
                    )
                  : "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="font-medium text-gray-700">Recommendations</span>
              <span className="text-gray-600">
                {computer.repairDetails?.Recommendations || "None"}
              </span>
            </div>
          </div>
        </section>

        {/* Repair History */}
        <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            Repair History
          </h2>
          {computer.repairHistory?.length > 0 ? (
            <div className="space-y-3">
              {computer.repairHistory.map((entry, index) => (
                <div
                  key={index}
                  className="bg-white p-3 rounded-md border-l-4 border-blue-500 text-sm"
                >
                  <p>
                    <span className="font-medium text-gray-700">Date: </span>
                    {entry.Date
                      ? new Date(entry.Date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      : "N/A"}
                  </p>
                  <p>
                    <span className="font-medium text-gray-700">
                      Description:{" "}
                    </span>
                    {entry.Description || "No description"}
                  </p>
                  <p>
                    <span className="font-medium text-gray-700">Status: </span>
                    {/* <span
                      className={`text-xs font-medium px-2 py-1 rounded-full ${
                        entry.Status?.toLowerCase() === "in_progress"
                          ? "bg-yellow-100 text-yellow-800"
                          : entry.Status?.toLowerCase() === "completed"
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {entry.Status || "Unknown"}
                    </span> */}
                    <span>{entry.Status}</span>
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 italic text-sm">
              No repair history available.
            </p>
          )}
        </section>

        {/* Change History */}
        <section className="bg-gray-50 p-4 sm:p-6 rounded-md border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            Change History
          </h2>
          {computer.changeHistory?.length > 0 ? (
            <div className="space-y-3">
              {computer.changeHistory.map((entry, index) => (
                <div
                  key={index}
                  className="bg-white p-3 rounded-md border-l-4 border-indigo-500 text-sm"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                      <p>
                        <span className="font-medium text-gray-700">
                          Modified By:{" "}
                        </span>
                        <span className="text-indigo-600">
                          {entry.ChangedBy || "Unknown"}
                        </span>
                      </p>
                      <p>
                        <span className="font-medium text-gray-700">
                          Date:{" "}
                        </span>
                        {entry.Date
                          ? new Date(entry.Date).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            })
                          : "N/A"}
                      </p>
                      <p>
                        <span className="font-medium text-gray-700">
                          Field Changed:{" "}
                        </span>
                        {entry.Field
                          ? entry.Field.split(/(?=[A-Z])|_/)
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ")
                          : "Unknown"}
                      </p>
                    </div>
                    <div>
                      <p>
                        <span className="font-medium text-gray-700">
                          Previous Value:{" "}
                        </span>
                        <span className="text-red-500 italic">
                          {entry.OldValue || "N/A"}
                        </span>
                      </p>
                      <p>
                        <span className="font-medium text-gray-700">
                          New Value:{" "}
                        </span>
                        <span className="text-green-500">
                          {entry.NewValue || "N/A"}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 italic text-sm">
              No change history available.
            </p>
          )}
        </section>
      </div>

      {/* Footer */}
      <footer className="mt-6 text-center text-gray-500 text-xs border-t pt-3">
        <p>
          Generated on{" "}
          {new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </p>
      </footer>
    </div>
  );
};

export default ComputerReport;
